/** Тип карточки СУ/УП */
export enum DepotCardType {
    /** Складской учёт (СУ) */
    Stock = 0,
    /** Учёт в производстве (УП) */
    Ws = 1,
}
